<template>
    <div class="single-crossselling__item" @click.stop="toggleOpeningState()" :class="{'is-open' : isOpen, 'is-selected' : isAdded}"
        :data-id="item.id" :data-itemid="item.data.item.id" :data-data="JSON.stringify(item)">
        <div class="single-crossselling__indicator single-crossselling__indicator--add" @click.stop="addItem()"
             data-container="body" data-html="true" data-trigger="hover" data-toggle="popover" data-placement="top"
             :data-content="$translate('ODKleinMore::Template.crosssellerAddItem')" :class="{ 'd-none' : isAdded }">
        <img :src="pluginPath + '/images/icon-plus.svg'">
    </div>
    <div class="single-crossselling__indicator single-crossselling__indicator--remove" :class="{ 'd-none' : !isAdded }"
         data-container="body" data-html="true" data-trigger="hover" data-toggle="popover" data-placement="top"
         :data-content="$translate('ODKleinMore::Template.crosssellerRemoveItem')" @click.stop="removeItem()">
        <img :src="pluginPath + '/images/icon-check.svg'">
    </div>
    <div class="single-crossselling__name">{{ item.data.texts.name1 }}</div>
    <div class="single-crossselling__price">+{{ item.data.prices.default.price.formatted }}</div>
    <div class="single-crossselling__info">
        <img :src="pluginPath + '/images/icon-info.svg'">
    </div>
    <div class="single-crossselling__item-info" :class="{'is-open' : isOpen}">
        <hr>
        <div class="single-crossselling__item-info-wrapper">
            <div class="single-crossselling__img-wrapper">
                <img :src="variationImage !== '' ? variationImage : item.data.images.all[0].urlMiddle" :alt="item.data.texts.name1">
            </div>
            <div class="single-crossselling__item-data">
                <div class="single-crossselling__inner-name">{{ item.data.texts.name1 }}</div>
                <table class="single-crossselling__table table">
                    <tbody>
                    <template v-if="colorLabel !== '' && color !== ''">
                    <tr>
                        <td :class="{'label-with-padding' : variationSelectData !== null}">{{ colorLabel }}</td>
                        <template v-if="variationSelectData === null">
                            <td>{{ color }}</td>
                        </template>
                        <template v-else>
                            <td v-if="variationSelectData !== null">
                                <div class="input-unit">
                                    <select class="custom-select" @click.stop @change="getVarImage($event.target.value)">
                                        <option v-for="color in variationSelectData[12].values" :value="color.variationId">{{ color.name }}</option>
                                    </select>
                                </div>
                            </td>
                        </template>
                    </tr>
                    </template>
                    <template v-if="sizeLabel !== '' && size !== ''">
                    <tr>
                        <td>{{ sizeLabel }}</td>
                        <td>{{ size }}</td>
                    </tr>
                    </template>
                    <template v-if="materialLabel !== '' && material !== ''">
                    <tr>
                        <td>{{ materialLabel }}</td>
                        <td>{{ material }}</td>
                    </tr>
                    </template>
                    </tbody>
                </table>
                <div class="single-crossselling__more-link">
                    <a target="_blank" :href="'/' + item.data.texts.urlPath + '/a-' + item.data.item.id" :title="item.data.texts.name1">
                        {{ $translate("ODKleinMore::Template.crosssellerMoreInfo") }}</a>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

import ApiService from "ceres/app/services/ApiService";

export default {
    name: "crossseller-item",

    props: {
        item: {
            type: [Object, Array],
            default: () => {}
        }
    },

    data(){
        return {
            color: "",
            colorLabel: "",
            size: "",
            sizeLabel: "",
            material: "",
            materialLabel: "",
            isOpen: false,
            isAdded: false,
            hasBeenOpenedOnce: false,
            variationSelectData: null,
            variationImage: ""
        }
    },

    mounted(){
        for(let key in this.item.data.attributes){
            if(this.item.data.attributes[key].attributeId === 12){
                this.color = this.item.data.attributes[key].value.names.name;
                this.colorLabel = this.item.data.attributes[key].attribute.names.name;
            }

            if(this.item.data.attributes[key].attributeId === 13){
                this.size = this.item.data.attributes[key].value.names.name;
                this.sizeLabel = this.item.data.attributes[key].attribute.names.name;
            }
        }

        for(let key in this.item.data.variationProperties){
            for(let innerKey in this.item.data.variationProperties[key].properties){
                if(this.item.data.variationProperties[key].properties[innerKey].id === 2){
                    this.material = this.item.data.variationProperties[key].properties[innerKey].values.value;
                    this.materialLabel = this.item.data.variationProperties[key].properties[innerKey].names.name;
                }
            }
        }
    },

    methods:{
        toggleOpeningState(){
            this.isOpen = !this.isOpen;

            if(!this.hasBeenOpenedOnce){
                this.hasBeenOpenedOnce = true;

                //ApiService.get("/rest/ODKleinMore/item-variation-attributes-map?id=" + this.item.data.item.id)
                ApiService.get("/rest/io/variations/map?itemId=" + this.item.data.item.id)
                    .done(response =>
                    {
                        let variationSelectData = {};

                        for(let attrId in response.attributes){

                            let values = [];

                            for(let valueId in response.attributes[attrId].values){
                                values.push({valueId: response.attributes[attrId].values[valueId].attributeValueId, name: response.attributes[attrId].values[valueId].name, variationId: null})
                            }

                            variationSelectData[response.attributes[attrId].attributeId] = {name: response.attributes[attrId].name, values: values};
                        }

                        if(Object.keys(variationSelectData).length){
                            // now add variationId from response.variationMap
                            for(let key in response.variations){
                                let variationMapAttrValueId = 0;
                                let variationMapAttrId = 0;
                                for(let innerKey in response.variations[key].attributes){
                                    variationMapAttrId = response.variations[key].attributes[innerKey].attributeId;
                                    variationMapAttrValueId = response.variations[key].attributes[innerKey].attributeValueId;
                                }

                                if(typeof variationSelectData[variationMapAttrId] !== "undefined"){
                                    for(let valueKey in variationSelectData[variationMapAttrId].values){
                                        if(variationSelectData[variationMapAttrId].values[valueKey].valueId == variationMapAttrValueId){
                                            variationSelectData[variationMapAttrId].values[valueKey].variationId = response.variations[key].variationId;
                                        }
                                    }
                                }
                            }

                            this.variationSelectData = variationSelectData;
                        }else{
                            this.variationSelectData = null;
                        }
                    })
            }
        },

        addItem(){
            this.isAdded = true;
        },

        removeItem(){
            this.isAdded = false;
        },

        getVarImage(varId){
            ApiService.get("/rest/ODKleinMore/item-variation-image?id=" + varId)
                .done(response =>
                {
                    if(response !== ""){
                        this.variationImage = response;
                    }
                })
        }
    },

    computed: {
        pluginPath(){
            return App.pluginPath;
        }
    }
};
</script>
